var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9475 5.84367C52.9107 6.68733 51.0848 8.51325 47.4332 12.1648C43.7825 15.8155 41.9558 17.6422 41.1123 19.6787C39.9874 22.3945 39.9874 25.4461 41.1123 28.1619C41.9559 30.1987 43.7818 32.0245 47.4334 35.6761C51.0829 39.3257 52.9111 41.1538 54.9473 41.9973C57.663 43.1221 60.7147 43.1221 63.4305 41.9972C65.4673 41.1536 67.2931 39.3278 70.9447 35.6761C74.5963 32.0245 76.4168 30.1987 77.2604 28.1619C78.3853 25.4461 78.3853 22.3945 77.2604 19.6787C76.4168 17.6419 74.5963 15.8164 70.9447 12.1648C67.2931 8.51319 65.4672 6.68733 63.4305 5.84367C60.7147 4.71878 57.6632 4.71878 54.9475 5.84367Z",
    stroke: "url(#paint0_linear_8920_3)",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6789 41.1096C17.6421 41.9532 15.8162 43.7791 12.1646 47.4307C8.51404 51.0813 6.68722 52.9081 5.84367 54.9446C4.71878 57.6603 4.71878 60.712 5.84367 63.4278C6.68733 65.4645 8.51319 67.2904 12.1648 70.942C15.8143 74.5915 17.6425 76.4197 19.6787 77.2631C22.3945 78.388 25.4461 78.388 28.1619 77.2631C30.1987 76.4195 32.0245 74.5936 35.6761 70.942C39.3277 67.2904 41.1482 65.4645 41.9918 63.4278C43.1167 60.712 43.1167 57.6603 41.9918 54.9446C41.1482 52.9078 39.3277 51.0823 35.6761 47.4307C32.0245 43.779 30.1987 41.9532 28.1619 41.1096C25.4461 39.9847 22.3946 39.9847 19.6789 41.1096Z",
    stroke: "url(#paint1_linear_8920_3)",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7018 47.4307C79.0512 51.0813 77.2244 52.9081 76.3809 54.9446C75.256 57.6603 75.256 60.712 76.3809 63.4278C77.2245 65.4645 79.0504 67.2904 82.702 70.942C86.3515 74.5915 88.1797 76.4197 90.2159 77.2631C92.9316 78.388 95.9833 78.388 98.6991 77.2631C100.736 76.4195 102.562 74.5936 106.213 70.942C109.865 67.2904 111.685 65.4645 112.529 63.4278C113.654 60.712 113.654 57.6603 112.529 54.9446C111.685 52.9078 109.865 51.0822 106.213 47.4307C102.562 43.7791 100.736 41.9532 98.6991 41.1096C95.9833 39.9847 92.9318 39.9847 90.2161 41.1096C88.1793 41.9532 86.3534 43.7791 82.7018 47.4307Z",
    stroke: "url(#paint2_linear_8920_3)",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9475 76.3782C52.9107 77.2218 51.0848 79.0477 47.4332 82.6993C43.7826 86.3499 41.9558 88.1767 41.1123 90.2132C39.9874 92.9289 39.9874 95.9806 41.1123 98.6963C41.9559 100.733 43.7818 102.559 47.4334 106.211C51.0829 109.86 52.9111 111.688 54.9473 112.532C57.663 113.657 60.7147 113.657 63.4305 112.532C65.4673 111.688 67.2931 109.862 70.9447 106.211C74.5963 102.559 76.4168 100.733 77.2604 98.6963C78.3853 95.9806 78.3853 92.9289 77.2604 90.2132C76.4168 88.1764 74.5963 86.3509 70.9447 82.6993C67.2931 79.0477 65.4673 77.2218 63.4305 76.3782C60.7147 75.2533 57.6632 75.2533 54.9475 76.3782Z",
    stroke: "url(#paint3_linear_8920_3)",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8920_3",
    x1: 59.1864,
    y1: 5,
    x2: 59.1864,
    y2: 113.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#674CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8920_3",
    x1: 59.1864,
    y1: 5,
    x2: 59.1864,
    y2: 113.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#674CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8920_3",
    x1: 59.1864,
    y1: 5,
    x2: 59.1864,
    y2: 113.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#674CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8920_3",
    x1: 59.1864,
    y1: 5,
    x2: 59.1864,
    y2: 113.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#674CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437CF3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.d3fada2c392afbf93492e97c533d7243.svg";
export { ForwardRef as ReactComponent };